import React from 'react';
import styles from './CardExpiredNotification.css';

const CardExpiredNotification = () => (
  <div className={styles.container}>
    <p>*The credit card we have on file has expired.</p>
    <p>Please update your payment information.</p>
  </div>
);

export default CardExpiredNotification;



// WEBPACK FOOTER //
// ./src/containers/CartPage/CardExpiredNotification.jsx